module.exports = __webpack_public_path__ + "img/frame (226).7b9022c2.jpg";